export const COLOR = {
  fontColorPrimary: "#2F3335",
  fontColorSecondary: "#F9F9F9",
  fontColorGray: "#7C7D7F",
  backgroundPrimary: "#EDEDED",
  backgroundSecondary: "#f7f7f7",
  fontDisabled: "#DCDCDC",
  btnBackground: "#D9D9D9",
  modalWhiteBackground: "#EDEDED",
};
